module.exports = __webpack_public_path__ + "img/euro-2020.64b6fed6.png";